import { supportedLangsByCode } from '@/constants/locales'

export function replaceLangInPath(currentPath: string, nextLang: string) {
  return currentPath.replace(/\/([^/]+)?/, `/${nextLang}`)
}

export function checkLangSupported(lang: string) {
  return lang in supportedLangsByCode
}
